var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _circle, _path17, _circle2, _path18, _circle3, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeepOceanThumbnail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#003C50",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6359 53.5417C21.0557 55.503 23.6595 66.7354 23.4967 68.1618L38.957 61.7432C35.3767 58.3556 27.5001 51.9727 24.6359 53.5417Z",
    fill: "#52BDA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6359 95.359C21.0557 93.3978 23.6595 82.1653 23.4967 80.739L38.957 87.1575C35.3767 90.5451 27.5001 96.928 24.6359 95.359Z",
    fill: "#52BDA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7039 75.0221C14.4796 71.8615 12.7657 64.9872 15.7039 62.7748C18.642 60.5624 16.9281 70.0178 15.7039 75.0221Z",
    fill: "#52BDA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7039 75.022C14.4796 77.8953 12.7657 84.1447 15.7039 86.1559C18.642 88.1672 16.9281 79.5714 15.7039 75.022Z",
    fill: "#52BDA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6188 57.8619C91.9225 59.9733 92.9997 65.5544 92.9997 73.8787L92.9999 74.3701C93.0049 86.4019 93.008 93.8879 65.4548 93.8879C38.4202 93.8879 19.1157 84.8041 17.9102 75.7341H17.0878C17.031 76.29 16.8938 76.8592 16.6378 77.4006C15.5465 79.7081 13 76.2469 13 75.0931C13 73.9394 16.2973 71.3755 16.6378 72.5293C16.7916 72.8907 16.9715 73.4876 17.0619 74.1958H17.8751C18.4277 67.0846 28.2415 61.9727 46.5018 59.1024C47.1771 56.8266 48.2787 53.6091 50.1213 52.2541C52.4867 50.5144 64.011 46.9305 69.3801 45.8822C68.9763 41.1087 69.1831 33.3329 71.5842 30.7176C74.894 27.1125 78.6187 27.074 81.1799 27.0475C81.7151 27.0419 82.1996 27.0369 82.6188 27C82.8964 27.4535 82.8274 28.2301 82.7364 29.2548C82.6816 29.8716 82.6188 30.5784 82.6188 31.3586C82.6188 31.7696 82.0187 31.7088 81.109 31.6167C79.465 31.4502 76.8098 31.1814 74.8582 33.4097C72.7609 35.8043 72.2053 41.727 72.2503 45.6063C75.7214 45.786 82.6188 47.3373 82.6188 52.2541V57.8619Z",
    fill: "#F1AE5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1342 50.1515C82.1843 45.7844 75.9797 44.393 72.264 44.0312C72.2482 44.5821 72.2441 45.1113 72.2499 45.6072C75.1675 45.7583 80.5058 46.8783 82.1342 50.1515ZM69.262 44.0165C65.0158 44.6499 52.4489 48.2542 51.4547 49.3052C50.9373 49.8523 50.9054 50.8167 51.041 51.7072C54.6409 49.851 64.5257 46.8309 69.3797 45.883C69.3304 45.3006 69.2902 44.6735 69.262 44.0165Z",
    fill: "#52BDA4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3042 59.3039C47.6324 58.4834 71.3826 58.0331 82.6193 57.7768C81.2046 56.9649 75.7803 55.3667 65.4005 55.4693C52.4257 55.5975 51.5071 50.4982 49.4457 52.6774C47.7966 54.4209 45.8297 57.4664 45.3042 59.3039Z",
    fill: "#F97953"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6161 32.7687C72.3849 36.0505 71.9888 42.7678 72.0696 45.7162C71.3421 41.3577 72.0696 32.7687 74.6161 30.4612C76.6532 28.6152 80.4769 29.0083 82.1341 29.4357V31.4868C80.5577 30.5467 76.8472 29.487 74.6161 32.7687Z",
    fill: "#F97953"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1031 73.7992C80.2061 76.0859 79.1972 75.5938 18.7981 76.1654C20.8689 84.9813 36.6067 90.3653 56.0718 92.436C88.518 94.7228 90.4465 87.052 92.1031 81.6681C92.1031 80.4895 92.1031 75.0416 92.1031 73.7992Z",
    fill: "#F97953"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7854 76.1654C16.3132 79.1831 13 76.7371 13 75.0221C13.7842 75.0975 16.0114 76.0936 16.7854 76.1654Z",
    fill: "#F97953"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.4149,
    ry: 14.931,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 62.2796 75.6669)",
    fill: "#4292A4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.17309,
    ry: 9.50153,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 62.2792 75.6669)",
    fill: "#A4D0DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5399 75.4497C76.5669 77.4295 76.2248 79.3955 75.533 81.2355C74.8413 83.0755 73.8136 84.7534 72.5084 86.1735C71.2033 87.5935 69.6464 88.728 67.9266 89.5119C66.2068 90.2959 64.3577 90.7141 62.4851 90.7426C60.6124 90.7711 58.7527 90.4094 57.0122 89.6781C55.2718 88.9469 53.6846 87.8603 52.3413 86.4806C50.9981 85.1009 49.925 83.4549 49.1834 81.6368C48.4419 79.8186 48.0463 77.8638 48.0193 75.8841L62.2796 75.6669L76.5399 75.4497Z",
    fill: "#33717F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3542 75.5513C71.3832 78.0957 70.4549 80.5482 68.7736 82.3691C67.0922 84.19 64.7954 85.2302 62.3886 85.2609C59.9818 85.2915 57.662 84.3102 55.9396 82.5327C54.2171 80.7551 53.2332 78.3271 53.2042 75.7826L62.2792 75.6669L71.3542 75.5513Z",
    fill: "#5BABBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8188 90.7794C39.2758 80.5293 41.3425 64.7316 42.8188 60.1322L40.2978 60.5302C37.6828 70.4846 38.7426 85.4251 39.9377 89.9834L42.8188 90.7794Z",
    fill: "#52BDA4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6342 90.8094C80.8053 79.2378 83.9284 64.6282 85.8909 59.2739L83.3774 58.4756C79.06 70.3373 79.3857 80.5872 82.1206 91.6077L84.6342 90.8094Z",
    fill: "#52BDA4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3193 66.7685C91.3196 65.2149 88.9008 62.5797 87.6913 61.4564C86.0205 61.0783 86.3334 63.0912 87.221 63.5348C88.1086 63.9784 88.7086 66.1777 88.9955 67.8206C89.2824 69.4635 91.3189 68.7105 91.3193 66.7685Z",
    fill: "#CCE6E2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7881 52.4508C80.4001 50.8099 77.0695 48.605 75.4527 47.7076C73.5126 47.7076 74.3614 49.7587 75.4527 50.0151C76.5441 50.2715 77.7567 52.4508 78.4842 54.1173C79.2118 55.7838 81.2732 54.5019 80.7881 52.4508Z",
    fill: "#CCE6E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5708,
    y: 72.7353,
    width: 15.1416,
    height: 5.71691,
    rx: 2.85846,
    fill: "#33717F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.25,
    cy: 31.5,
    r: 6.75,
    fill: "#8BA2C0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9693 31.4089C47.9847 32.7609 47.6751 30.4663 46.0786 29.3034C44.482 28.1406 42.2031 28.5499 43.1878 27.1979C44.1725 25.846 46.265 25.6927 47.8615 26.8555C49.458 28.0183 49.954 30.057 48.9693 31.4089Z",
    fill: "#516D95"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.375,
    cy: 10.875,
    r: 4.875,
    transform: "rotate(-90 24.375 10.875)",
    fill: "#8BA2C0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3092 7.46671C25.2856 8.17787 23.6284 8.40144 22.7886 9.5545C21.9488 10.7076 22.2444 12.3535 21.268 11.6423C20.2915 10.9311 20.1808 9.41988 21.0206 8.26682C21.8605 7.11376 23.3328 6.75554 24.3092 7.46671Z",
    fill: "#516D95"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.875,
    cy: 39.375,
    r: 4.875,
    transform: "rotate(-90 16.875 39.375)",
    fill: "#8BA2C0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8092 35.9667C17.7856 36.6779 16.1284 36.9014 15.2886 38.0545C14.4488 39.2076 14.7444 40.8535 13.768 40.1423C12.7915 39.4311 12.6808 37.9199 13.5206 36.7668C14.3605 35.6138 15.8328 35.2555 16.8092 35.9667Z",
    fill: "#516D95"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeepOceanThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeepOceanThumbnail.71720f8df6448a0f18e34c0f4d5a5abd.svg";